export default 'freeridePage';
